<template>
  <div>
    <div v-if="ListingItemType.EMBEDDED === contentItem.type">
      <h3>{{ contentItem.name }}</h3>
      <div v-if="contentItem.description" class="pb-5 rich-text" v-html="contentItem.description" />
      <div class="rich-text" v-html="contentItem.content" />
    </div>

    <div v-if="ListingItemType.FILE === contentItem.type" class="pb-10">
      <h3>{{ contentItem.name }}</h3>
      <div class="rich-text" v-html="contentItem.description" />
      <d-btn outline color="primary-500" class="mt-5" size="sm" target="_blank" @click="downloadItem()">
        Download File
      </d-btn>
    </div>

    <div v-if="ListingItemType.LINK === contentItem.type" class="pb-10">
      <h3>{{ contentItem.name }}</h3>
      <div class="rich-text" v-html="contentItem.description" />
      <d-btn outline color="primary-500" class="mt-5" size="sm" target="_blank" @click="downloadItem()">
        View Link
      </d-btn>
    </div>

    <slot name="pagination" />
  </div>
</template>

<script>
  import { ListingItemType, ContentListingInteractionType } from '@resources/scripts/constants';
  import { useAuthStore } from '@stores/auth';
  import axios from 'axios';

  export default {
    inject: ['contentListing'],
    props: {
      contentItem: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        ListingItemType,
        auth: null,
      };
    },

    computed: {
      // Use Pinia auth store's profile
      profile() {
        return this.auth ? this.auth.profile || {} : {};
      },
    },
    mounted() {
      this.auth = useAuthStore();
    },

    methods: {
      async downloadItem() {
        // Submit the interaction for historical tracking
        if (this.profile && this.contentItem.type === ListingItemType.FILE) {
          await axios.post(`/api/content-listings/${this.contentListing.id}/interactions`, {
            type: ContentListingInteractionType.DOWNLOAD,
            userId: this.profile.id,
            contentListingId: this.contentListing.id,
            contentListingItemId: this.contentItem.id,
            startTime: new Date(),
            stopTime: new Date(),
          });
        }

        // Download the file
        const { data } = await axios.get(`/api/content-listings/items/interactive/${this.contentItem.id}/download-url`);
        const ios = navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad)/);
        if (ios) {
          window.location.href = data;
        } else {
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.style = 'display: none';
          a.target = '_blank';
          a.href = data;
          a.click();
          document.body.removeChild(a);
        }
      },
    },
  };
</script>